import * as React from 'react';
import { NumericTextBox } from '@progress/kendo-react-inputs';
/** @hidden */
export var RecurrenceIntervalEditor = function (props) {
    var titleClassName = props.titleClassName, editorClassName = props.editorClassName, title = props.title, frequencyText = props.frequencyText, interval = props.interval, onIntervalChange = props.onIntervalChange;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: titleClassName },
            React.createElement("label", null, title)),
        React.createElement("div", { className: editorClassName },
            React.createElement("div", null,
                React.createElement(NumericTextBox, { value: interval || 1, min: 1, step: 1, width: 70, onChange: onIntervalChange }),
                "\u00A0",
                frequencyText))));
};
//# sourceMappingURL=RecurrenceIntervalEditor.js.map